export const getScheduleUrl = (type: string, templateId?: string | null, id?: string | null): string => {
    switch (type) {
        case "template":
        case "profile": {
            return id
                ? `/shift-templates/v2/${templateId}/${id}`
                : `/shift-templates/v2/${templateId}`;
        }
        case "my-profile": {
            return id
                ? `/my/shift-templates/v2/${templateId}/${id}`
                : `/my/shift-templates/v2/${templateId}`;
        }
        case "home": {
            return id
                ? `/my/schedules/v2/${id}`
                : `/my/schedules/v2`;
        }
        default: {
            return id
                ? `/schedules/v2/${id}`
                : `/schedules/v2`;
        }
    }
};
